import * as moment from 'moment';
import { TokenResponse } from './TokenResponse';

const computeExpiryTime = (data: TokenResponse) => {
    const now = moment();
    const serverExpiryTime = moment(data['.expires']).add(-15, 's');
    const estimatedExpiryTime = now.add(data.expires_in, 's');
    const evaluatedDate = moment.min(serverExpiryTime, estimatedExpiryTime).toISOString();
    return evaluatedDate;
};

export default computeExpiryTime;